import React from "react";

// The icon-font bundle only ships an "upload"-shaped glyph under the "download"
// name, so we use a small inline SVG (matching the reference design) instead.
const DownloadIcon = ({ className, width = 20, height = 20 }) => (
  <svg
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    stroke="currentColor"
    strokeWidth="2"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 3v12" />
    <path d="M8 11l4 4 4-4" />
    <path d="M4 21h16" />
  </svg>
);

export default DownloadIcon;
